import dashboard from '../../src/assets/icon-add-circle.svg';
import layers from '../../src/assets/icon-layers.svg';
import agent from '../../src/assets/icon-agent.svg';
import team from '../../src/assets/icon-team.svg';
import toolsIcon from '../../src/assets/toolsIcon.svg';
import skillsIcon from '../../src/assets/skillsIcon.svg';
import workflowIcon from '../../src/assets/workflowIcon.svg';
import iconAdd from '../../src/assets/icon-add.svg';

export const NavData = [
  {
    path: 'dashboard',
    file: 'new-chat',
    img: dashboard,
    name: 'Ferdy Chat',
    haskey: true,
  },
  {
    path: 'create-agent',
    file: 'create-agent',
    img: iconAdd,
    name: 'Create Agent',
    haskey: true,
  },
  {
    path: 'projects',
    file: 'projects',
    img: layers,
    name: 'Projects',
  },
  {
    path: 'agents',
    file: 'agents',
    img: agent,
    name: 'Agents',
  },
  {
    path: 'team',
    file: 'team',
    img: team,
    name: 'Team',
  },
  {
    path: 'tools',
    file: 'tools',
    img: toolsIcon,
    name: 'Tools',
  },
  {
    path: 'skills',
    file: 'skills',
    img: skillsIcon,
    name: 'Skills',
  },
  {
    path: 'workflows',
    file: 'create-workflow',
    img: workflowIcon,
    name: 'Workflows',
  },
];
